import styled from 'styled-components';

const MaxWidthDiv = styled.div`
  max-width: ${({ maxWidth }) => maxWidth || '200px'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default MaxWidthDiv;
